import React from 'react';
import { useTranslation } from 'react-i18next';
import { X, AlertTriangle, Trash2, Loader2 } from 'lucide-react';
import './DeleteVideoModal.css';

export default function DeleteVideoModal({ isOpen, onClose, onConfirm, isDeleting = false, isRtl }) {
  const { t, i18n } = useTranslation();
  const isHebrew = i18n.language && i18n.language.startsWith('he');
  const rtlClass = isHebrew || isRtl ? 'deleteVideoModal--rtl' : '';

  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget && !isDeleting) {
      onClose();
    }
  };

  const handleConfirm = () => {
    if (!isDeleting) {
      onConfirm();
    }
  };

  return (
    <div 
      className={`deleteVideoModal__overlay ${rtlClass}`} 
      onClick={handleOverlayClick}
      role="dialog"
      aria-modal="true"
      aria-labelledby="deleteVideoModal-title"
      aria-describedby="deleteVideoModal-description"
    >
      <div className="deleteVideoModal__content" onClick={(e) => e.stopPropagation()}>
        <button 
          className="deleteVideoModal__close" 
          onClick={onClose}
          disabled={isDeleting}
          aria-label={t('common.buttons.close', 'Close')}
        >
          <X size={20} />
        </button>
        
        <div className="deleteVideoModal__icon">
          <div className="deleteVideoModal__iconWrapper">
            <AlertTriangle size={40} className="deleteVideoModal__iconMain" />
          </div>
        </div>
        
        <h2 className="deleteVideoModal__title" id="deleteVideoModal-title">
          {t('analysisPage.deleteVideoConfirm', 'Are you sure you want to delete this video?')}
        </h2>
        
        <p className="deleteVideoModal__message" id="deleteVideoModal-description">
          {t('analysisPage.deleteVideoWarning', 'This will permanently delete the video file. This action cannot be undone. Your analysis will remain available.')}
        </p>
        
        <div className="deleteVideoModal__actions">
          <button 
            className="deleteVideoModal__button deleteVideoModal__button--danger" 
            onClick={handleConfirm}
            disabled={isDeleting}
            aria-label={t('analysisPage.deleteVideoButton', 'Delete Video')}
          >
            {isDeleting ? (
              <>
                <Loader2 size={18} className="deleteVideoModal__spinner" />
                <span>{t('common.buttons.loading', 'Loading...')}</span>
              </>
            ) : (
              <>
                <Trash2 size={18} />
                <span>{t('analysisPage.deleteVideoButton', 'Delete Video')}</span>
              </>
            )}
          </button>
          <button 
            className="deleteVideoModal__button deleteVideoModal__button--secondary" 
            onClick={onClose}
            disabled={isDeleting}
            aria-label={t('analysisPage.deleteVideoCancel', 'Cancel')}
          >
            {t('analysisPage.deleteVideoCancel', 'Cancel')}
          </button>
        </div>
      </div>
    </div>
  );
}

